import State from '../interfaces/states/State';

import { createSelector } from 'reselect';
import getMonthActivityArray from './getMonthActivityArray';

const getFilteredActivityMonthes = createSelector(
  (state: State) => getMonthActivityArray(state),
  (activityArray): number[] => {
    if (activityArray) {
      return activityArray.filter(function (item, pos) {
        // tslint:disable-next-line:triple-equals
        return activityArray.indexOf(item) == pos;
      });
    } else {
      return null;
    }
  }
);

export default getFilteredActivityMonthes;
